import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllSufferer = async () => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/sufferer');
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const getSuffererByID = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.get(`/sufferer/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const updateSufferer = async (id, data) => {
    try {
        await isAccessTokenValid();
        const response = await api.put(`/sufferer/${id}`, data);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const resetPassword = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.put(`/sufferer/${id}/reset-password`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
